var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "content" }, [
        _c("div", {
          staticClass: "wrap-left",
          class: {
            "yts-icon": !_vm.appConfig.backgroundUrl || !_vm.appConfigValid
          }
        }),
        _c(
          "div",
          { staticClass: "warp-view" },
          [
            _c(
              "transition",
              { attrs: { name: "slide-fade" } },
              [_c(_vm.currentLoginType, { tag: "component" })],
              1
            )
          ],
          1
        )
      ]),
      _c("Protocol-com"),
      _c("Privacy-com")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }